import gql from 'graphql-tag';

export default gql`
query getPirschData($obj: getPirschDataInput!) {
  getPirschData(object: $obj) {
    result
  }
}
`;
